/** Namespace `einvoiceAgency` — EINV-2026-020 GĐ7: trang « Đại lý HĐĐT » (kênh đại lý qua bube-einvoice). */
export const einvoiceAgency = {
  title: "Đại lý HĐĐT",
  subtitle: "{product} · {env}",
  intro:
    "Bube là ĐẠI LÝ của nhà cung cấp: tạo tài khoản + gói hoá đơn cho khách, cấp / thu hồi số lượng, gia hạn, tạm ngừng, sửa liên hệ. Lệnh chạy ở bube-einvoice bằng bộ thông số đại lý ĐANG GÁN ở hub; mỗi thao tác có khoá chống trùng — gửi lại không cấp lần hai.",
  notAgency: "Dịch vụ này không có kênh đại lý trong danh mục.",
  readOnlyRole: "Vai trò của bạn chỉ đọc — thao tác đại lý cần quyền ghi tích hợp.",
  envSandbox: "Sandbox (demo)",
  envLive: "Live",
  commercialTitle: "Quyền bán của Bube",
  commercialIntro:
    "Có API đại lý ≠ được bán. « Mua qua Bube » và thao tác đại lý ở live chỉ mở khi quyền bán là « Đang hiệu lực ». Đổi ở đây có hiệu lực ngay (hub đẩy cấu hình sang app), không cần deploy.",
  "status.unverified": "Chưa xác minh",
  "status.negotiating": "Đang đàm phán",
  "status.active": "Đang hiệu lực",
  "status.suspended": "Tạm ngừng",
  "status.expired": "Đã hết hạn",
  effectiveStatus: "Trạng thái hiệu lực",
  statusField: "Trạng thái quyền bán",
  contractRef: "Số hợp đồng",
  effectiveFrom: "Hiệu lực từ",
  effectiveUntil: "Hiệu lực đến",
  note: "Ghi chú",
  save: "Lưu quyền bán",
  saved: "Đã lưu quyền bán. Trạng thái đẩy cấu hình sang app ở dưới.",
  updatedBy: "Cập nhật {at} bởi {by}",
  neverSet: "Chưa khai — mặc định « Chưa xác minh ».",
  operationTitle: "Thao tác",
  "op.account_create": "Tạo khách + gói",
  "op.quota_adjust": "Cấp / thu hồi số lượng",
  "op.renew": "Gia hạn",
  "op.suspend": "Tạm ngừng",
  "op.contact_update": "Sửa liên hệ",
  "direction.outbound": "Bán ra",
  "direction.inbound": "Mua vào",
  customerName: "Tên khách hàng",
  taxCode: "Mã số thuế",
  address: "Địa chỉ",
  email: "Email",
  phone: "Số điện thoại",
  fax: "Fax",
  years: "Số năm",
  quantity: "Số lượng (âm = thu hồi)",
  services: "Gói dịch vụ",
  directions: "Loại hoá đơn",
  confirmLive: "Live: gõ lại mã số thuế của khách để xác nhận thao tác thật",
  run: "Gửi lệnh",
  running: "Đang gửi…",
  failed: "Không gửi được: {error}",
  resultTitle: "Kết quả",
  historyTitle: "Lịch sử thao tác",
  historyEmpty: "Chưa có thao tác nào ở môi trường này.",
  historyFailed: "Không tải được lịch sử: {error}",
  "result.succeeded": "Thành công",
  "result.rejected": "Bị từ chối",
  "result.unknown": "Chưa rõ — đối soát",
  "result.pending": "Đang chạy",
  resultUnavailable: "Nhà cung cấp báo khoá đã xử lý — thao tác đã tới nhà, không có kết quả để hiện.",
  attempts: "{n} lượt",
  traceId: "Mã truy vết: {id}",
  retry: "Thử lại cùng khoá",
  retryAt: "Thử lại được lúc {at}",
  createdAt: "Lúc",
} as const;
